export default {
    getters: {
        analyticsData(state) {
            return state.analyticsData
        },
        chartXDataArray(state) {
            return state.chartXDataArray
        },
        chartYDataArray(state) {
            return state.chartYDataArray
        },
        softwareData(state) {
            return state.softwareData
        },

        seriesNamesSum(state) {
            return state.seriesNamesSum
        },
        chartSeriesSum(state) {
            return state.chartSeriesSum
        },
        seriesNamesDetail(state) {
            return state.seriesNamesDetail
        },
        chartSeriesDetail(state) {
            return state.chartSeriesDetail
        },
    },
    state: {
        analyticsData: [],
        chartXDataArray: [],
        chartYDataArray: [],
        softwareData: [],

        seriesNamesSum: [],
        chartSeriesSum: [],
        seriesNamesDetail: [],
        chartSeriesDetail: [],
    },
    mutations: {
        setAnalyticsData(state, analyticsData) {
            state.analyticsData = analyticsData
        },
        setChartXDataArray(state, chartXDataArray) {
            state.chartXDataArray = chartXDataArray
        },
        setChartYDataArray(state, chartYDataArray) {
            state.chartYDataArray = chartYDataArray
        },
        setSoftwareData(state, softwareData) {
            state.softwareData = softwareData
        },

        setSeriesNamesSum(state, seriesNamesSum) {
            state.seriesNamesSum = seriesNamesSum;
        },
        setChartSeriesSum(state, chartSeriesSum) {
            state.chartSeriesSum = chartSeriesSum;
        },
        setSeriesNamesDetail(state, seriesNamesDetail) {
            state.seriesNamesDetail = seriesNamesDetail;
        },
        setChartSeriesDetail(state, chartSeriesDetail) {
            state.chartSeriesDetail = chartSeriesDetail;
        },
    },
    actions: {
        async createSoftwareData({ dispatch, commit }) {
            const response = await dispatch('apiRequest', {
                endpoint: 'softwares',
                method: 'GET'
            });
            const responseData = await response.json();
            commit('setSoftwareData', responseData);
        },
        async createAnalyticsData({ dispatch, commit }, { dateBegin, dateEnd, data }) {
            const response = await dispatch('apiRequest', {
                endpoint: 'metrics?date_begin=' + dateBegin + '&date_end=' + dateEnd,
                method: 'POST',
                data: { 'codes': data },
            });
            const responseData = await response.json();
            const reversedData = [...responseData].reverse();

            commit('setAnalyticsData', reversedData) // переворачиваю массив для таблицы
            const date = responseData.map(v => v.date)
            commit('setChartXDataArray', date)

            const outputData = [];
            const seriesData = {};

            const softwareNamesObj = await dispatch('apiRequest', {
                endpoint: 'softwares',
                method: 'GET'
            })
            const softwareNames = await softwareNamesObj.json()
            const seriesNames = Object.values(softwareNames); // такой результат ['ProCart', 'ProQRPay', ...]
            seriesNames.forEach(seriesName => {
                seriesData[seriesName] = { name: seriesName, data: [] };
            });

            responseData.forEach(item => {
                seriesNames.forEach(seriesName => {
                    seriesData[seriesName].data.push(item[seriesName] || 0);
                });
            });

            // Преобразую объект в массив и удаляем серии с нулевыми значениями
            for (const key in seriesData) {
                if (seriesData[key].data.some(value => value !== 0)) {
                    outputData.push(seriesData[key]);
                }
            }
            // console.log(outputData);
            commit('setChartYDataArray', outputData)
        },

        async createBaseMetricsSum({ dispatch, commit }, { dateBegin, dateEnd, data }) {
            commit('setSeriesNamesSum', []);
            commit('setChartSeriesSum', [])
            const response = await dispatch('apiRequest', {
                endpoint: 'base_metrics_sum?date_begin=' + dateBegin + '&date_end=' + dateEnd,
                method: 'POST',
                data: { 'codes': data },
            });
            const responseData = await response.json();

            if (responseData) {
                if (Object.keys(responseData).length === 0) {
                    return false;
                }
                commit('setSeriesNamesSum', Object.keys(responseData));
                commit('setChartSeriesSum', [{ name:'Количество', data: Object.values(responseData) }])
            }

            return responseData;
        },

        async createBusinessMetricsSum({ dispatch, commit }, { dateBegin, dateEnd, data }) {
            commit('setSeriesNamesSum', []);
            commit('setChartSeriesSum', [])
            const response = await dispatch('apiRequest', {
                endpoint: 'business_metrics_sum?date_begin=' + dateBegin + '&date_end=' + dateEnd,
                method: 'POST',
                data: { 'codes': data },
            });
            const responseData = await response.json();

            if (responseData) {
                if (Object.keys(responseData).length === 0) {
                    return false;
                }
                commit('setSeriesNamesSum', Object.keys(responseData));
                commit('setChartSeriesSum', [{ name:'Количество', data: Object.values(responseData) }])
            }

            return responseData;
        },
        async createBaseMetricsDetail({ dispatch, commit }, { dateBegin, dateEnd, data }) {
            commit('setSeriesNamesDetail', []);
            commit('setChartSeriesDetail', [])
            const response = await dispatch('apiRequest', {
                endpoint: 'base_metrics_detail?date_begin=' + dateBegin + '&date_end=' + dateEnd,
                method: 'POST',
                data: { 'codes': data },
            });
            const responseData = await response.json();

            if (!responseData || Object.keys(responseData).length === 0) {
                return false;
            }

            const users = Object.keys(responseData[Object.keys(responseData)[0]]);  

            const methodAverages = Object.entries(responseData).map(([method, usersObj]) => {
                const values = Object.values(usersObj).map(v => v || 0);
                const avg = values.reduce((a, b) => a + b, 0) / values.length;
                return { method, avg };
            });

            methodAverages.sort((a, b) => b.avg - a.avg);
            const sortedMethods = methodAverages.map(item => item.method);
            const sortedResultArray = users.map(user => {
                const dataValues = sortedMethods.map(method => responseData[method][user] ?? 0);
                return {
                    name: user,
                    data: dataValues,
                };
            });

            commit('setSeriesNamesDetail', sortedMethods);
            commit('setChartSeriesDetail', sortedResultArray);

            return responseData;
        },

        async createBusinessMetricsDetail({ dispatch, commit }, { dateBegin, dateEnd, data }) {
            commit('setSeriesNamesDetail', []);
            commit('setChartSeriesDetail', []);

            const response = await dispatch('apiRequest', {
                endpoint: 'business_metrics_detail?date_begin=' + dateBegin + '&date_end=' + dateEnd,
                method: 'POST',
                data: { 'codes': data },
            });

            const responseData = await response.json();
            if (!responseData || Object.keys(responseData).length === 0) {
                return false;
            }

            const methods = Object.keys(responseData);
            let users = Object.keys(responseData[methods[0]]);

            const firstMethod = methods[0];
            const sortedPairs = users.map(user => ({
                user,
                value: responseData[firstMethod][user] ?? 0
            })).sort((a, b) => b.value - a.value);

            users = sortedPairs.map(p => p.user);

            const series = methods.map(method => {
                const values = users.map(user => responseData[method][user] ?? 0);
                return {
                    name: method,
                    data: values,
                };
            });

            commit('setSeriesNamesDetail', users);
            commit('setChartSeriesDetail', series);
            return responseData;
        },
    }
}
